import { Box, Typography } from '@mui/material';
import { PanelCard } from './PanelCard';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import HandshakeIcon from '@mui/icons-material/Handshake';
import Diamond from '@mui/icons-material/Diamond';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import BadgeIcon from '@mui/icons-material/Badge';
import { checkUserPermission } from '@common/auth';
import useUserStore from 'store/user.store';
import { t } from 'i18next';
import { theme } from '@store';

export const PanelLanding = () => {
  const { user } = useUserStore();

  const PanelCards = [
    {
      id: 1,
      img: (
        <ApartmentIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/organization',
      type: 'manage_organizations',
      title: t('adminPanel.panelCards.organizations.title'),
      subtitle: t('adminPanel.panelCards.organizations.subtitle'),
    },
    {
      id: 2,
      img: (
        <AssignmentIndIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/user',
      type: 'manage_users',
      title: t('adminPanel.panelCards.users.title'),
      subtitle: t('adminPanel.panelCards.users.subtitle'),
    },
    {
      id: 3,
      img: (
        <HandshakeIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/partner',
      type: 'manage_partners',
      title: t('adminPanel.panelCards.partners.title'),
      subtitle: t('adminPanel.panelCards.partners.subtitle'),
    },
    {
      id: 4,
      img: (
        <Diamond
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/team',
      type: 'manage_teams',
      title: t('adminPanel.panelCards.teams.title'),
      subtitle: t('adminPanel.panelCards.teams.subtitle'),
    },
    {
      id: 5,
      img: (
        <MedicalServicesIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/practice',
      type: 'manage_practices',
      title: t('adminPanel.panelCards.practices.title'),
      subtitle: t('adminPanel.panelCards.practices.subtitle'),
    },
    {
      id: 6,
      img: (
        <PermPhoneMsgIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/operator',
      type: 'manage_operators',
      title: t('adminPanel.panelCards.operators.title'),
      subtitle: t('adminPanel.panelCards.operators.subtitle'),
    },
    {
      id: 7,
      img: (
        <MapsHomeWorkIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/building',
      type: 'manage_buildings',
      title: t('adminPanel.panelCards.buildings.title'),
      subtitle: t('adminPanel.panelCards.buildings.subtitle'),
    },
    {
      id: 8,
      img: (
        <BadgeIcon
          color='primary'
          sx={{ width: 56, height: 56, marginTop: 2, marginLeft: 2 }}
        />
      ),
      navigateTo: '/admin/provider',
      type: 'manage_providers',
      title: t('adminPanel.panelCards.providers.title'),
      subtitle: t('adminPanel.panelCards.providers.subtitle'),
    },
  ];
  return (
    <>
      <Typography
        variant='h4'
        sx={{
          mb: 2,
          mt: 2,
        }}
      >
        {t('adminPanel.title')}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: 2,
          [theme.breakpoints.up('md')]: {
            gridTemplateColumns: '1fr 1fr 1fr 1fr',
          },
        }}
      >
        {PanelCards.map(item => {
          if (checkUserPermission(user, item?.type)) {
            return <PanelCard item={item} key={item?.id} />;
          } else {
            return null;
          }
        })}
      </Box>
    </>
  );
};
